<div id="summary-content">
    <div class="survey-step-header">
        <h3 class="survey-step-title">Section 1: Other Health Insurance</h3>
    </div>
    <label class="label-question br-1">
        Other Commercial Plan(s)
    </label>
    <div *ngFor="let policy of PolicyHolders; let i = index" [id]="'summary-oth-view+'+i">
        <app-other-health-insurance-view [PolicyHolder] = "policy" [Index]="i" ></app-other-health-insurance-view>
        <mat-divider></mat-divider>
    </div>
    <div id="summary-medicare" *ngIf="MedicareForm" [formGroup]="MedicareForm" class="form-section mt-1rem mb-1rem">
        <label class="label-question mb-2rem">
            Medicare
        </label>
        <div id="summary-medicare-form" class="inline-item">
            <enterprise-text-input  [InputId]="'summary-medicare-input-name'"
                                    [InputName]="'Name of Medicare Beneficiary'"
                                    Label="Name of Medicare Beneficiary"
                                    formControlName="InsuranceNameBeneficiary"
                                    class="inline-form-input"
                                    [Appearance]="'outline'">
            </enterprise-text-input>
            <enterprise-text-input  [InputId]="'summary-medicare-input-medicare-id'"
                                    [InputName]="'InsuranceMedicareId'"
                                    Label="Medicare ID #"
                                    formControlName="InsuranceMedicareId"
                                    class="inline-form-input"
                                    [Appearance]="'outline'">
            </enterprise-text-input>
            <enterprise-date-input  [InputId]="'summary-medicare-date-effecitve-date-a'"
                                    [InputName]="'InsuranceEffectiveDateHospital'"
                                    Label="Effective Date - Hospital (Part A)"
                                    formControlName="InsuranceEffectiveDateHospital"
                                    class="inline-form-input"
                                    [ReadOnly]="true"
                                    [Appearance]="'outline'">
            </enterprise-date-input>
            <enterprise-date-input  [InputId]="'summary-medicare-date-effecitve-date-b'"
                                    [InputName]="'InsuranceEffectiveDateMedical'"
                                    Label="Effective Date - Medical (Part B)"
                                    formControlName="InsuranceEffectiveDateMedical"
                                    class="inline-form-input"
                                    [ReadOnly]="true"
                                    [Appearance]="'outline'">
            </enterprise-date-input>
        </div>
    </div>
    <div class="survey-step-header">
        <h3 class="survey-step-title">Section 2: Social Security Benefits</h3>
    </div>
    <div id="summary-ssb-form" *ngIf="SocialSecurityBenefitForm" [formGroup]="SocialSecurityBenefitForm" class="form-section mt-2rem mb-1rem">
        <div id="summary-ssb-form-section" class="inline-item">
            <div class="summary-social-security-benefits">
                <machinify-enterprise-yes-no id="summary-ssb-input-hasrecievedssb"
                    #HasReceivedSocialSecurityBenefits
                    formControlName="HasReceivedSocialSecurityBenefits"
                    [Hidden]="false"
                    class="question-answer-input"
                    [HideIfDisabled]="false"
                    [Disabled]="true"
                    [Label]="SELF"
                    [ShowLabel]="true"
                    [InputId]="'summary-ssb-input-hasrecievedssb'"
                    [InputName]="'HasReceivedSocialSecurityBenefits'">
                </machinify-enterprise-yes-no>
                <enterprise-date-input id="summary-ssb-date-doa"
                        Label="Date of Application"
                        formControlName="DateOfApplication"
                        class="inline-form-date-input"
                        [Appearance]="'outline'"
                        [ReadOnly]="true"
                        [InputId]="'summary-ssb-date-doa'"
                        [InputName]="'DateOfApplication'">
                </enterprise-date-input>
            </div>
            <div class="summary-social-security-benefits">
                <app-toggle-confirm-dialog  id="summary-ssb-toggle-isspousereceivingssb"
                                            #SpouseReceivingSocialSecurityBenefits
                                            formControlName="IsSpouseReceivingSocialSecurityBenefits"
                                            class="question-answer-input"
                                            [Label]="SPOUSE"
                                            [ShowLabel]="true"
                                            [ShowConfirmDialogForNO]="false"
                                            [ShowConfirmDialogForU]="false"
                                            [SkipModal]="true"
                                            [ShowButtonU]="true"
                                            [Disabled]="true"
                                            [HideIfDisabled]="false"
                                            [InputId]="'summary-ssb-toggle-isspousereceivingssb'"
                                            [InputName]="'IsSpouseReceivingSocialSecurityBenefits'">
                </app-toggle-confirm-dialog>
                <enterprise-date-input id="summary-ssb-date-sdoa"
                        Label="Date of Application"
                        formControlName="SpouseDateOfApplication"
                        class="inline-form-date-input spouse-date"
                        [Appearance]="'outline'"
                        [ReadOnly]="true"
                        [InputId]="'summary-ssb-date-sdoa'"
                        [InputName]="'SpouseDateOfApplication'">
                </enterprise-date-input>
            </div>
        </div>
    </div>
    <div class="survey-step-header">
        <h3 class="survey-step-title">Section 3: Employment Status</h3>
    </div>
    <div id="summary-es-form" *ngIf="EmploymentStatusForm" [formGroup]="EmploymentStatusForm" class="form-section mt-1rem mb-1rem">
        <div id="summary-es-form-section-1" class="inline-item">
            <enterprise-text-input  [InputId]="'summary-es-input-name'"
                                    [InputName]="'Name'"
                                    Label="Your Name"
                                    formControlName="Name"
                                    class="inline-form-input"
                                    [Appearance]="'outline'"
                                    [ReadOnly]="true">
            </enterprise-text-input>
            <enterprise-date-input  id="summary-es-date-dlw"
                                    Label="Date last worked"
                                    formControlName="DateLastWorked"
                                    class="inline-form-input"
                                    [Appearance]="'outline'"
                                    [ReadOnly]="true"
                                    [InputId]="'summary-es-date-dlw'"
                                    [InputName]="'DateLastWorked'">
            </enterprise-date-input>
        </div>
        <div id="summary-es-form-section-2" class="inline-item">
            <enterprise-text-input  [InputId]="'summary-es-input-employer-name'"
                                    [InputName]="'EmployerName'"
                                    [Label]="CurrentlyWorking ? 'Name of Current Employer' : 'Name of Former Employer'"
                                    formControlName="EmployerName"
                                    class="inline-form-input"
                                    [Appearance]="'outline'"
                                    [ReadOnly]="true">
            </enterprise-text-input>
            <enterprise-text-input  [InputId]="'summary-es-input-employer-phone'"
                                    [InputName]="'EmployerPhone'"
                                    [Label]="CurrentlyWorking ? 'Current Employer #' : 'Former Employer #'"
                                    formControlName="EmployerPhone"
                                    ButtonIcon="phone"
                                    [ButtonDisabled]="true"
                                    [Mask]="PhoneFormat"
                                    [ShowButton]="true"
                                    class="inline-form-input"
                                    [Appearance]="'outline'"
                                    [ReadOnly]="true">
            </enterprise-text-input>
        </div>
        <div id="summary-es-form-section-3" *ngIf="ShowSpouseCurrentlyWorking">
            <div class="inline-item">
                <enterprise-text-input  [InputId]="'summary-es-input-spouse-name'"
                                        [InputName]="'SpouseName'"
                                        Label="Name of Spouse"
                                        formControlName="SpouseName"
                                        class="inline-form-input"
                                        [Appearance]="'outline'">
                </enterprise-text-input>
                <enterprise-date-input  [InputId]="'summary-es-date-spouse-dlw'"
                                        [InputName]="'SpouseDateLastWorked'"
                                        id="summary-es-date-spouse-dlw"
                                        Label="Date last worked"
                                        formControlName="SpouseDateLastWorked"
                                        class="inline-form-input"
                                        [Appearance]="'outline'"
                                        [ReadOnly]="true">
                </enterprise-date-input>
            </div>
            <div class="inline-item">
                <enterprise-text-input  [InputId]="'summary-es-input-spouse-employer-name'"
                                        [InputName]="'SpouseDateLastWorked'"
                                        [Label]="SpouseCurrentlyWorking.value === 'Yes' ? 'Name of Current Employer' : 'Name of Former Employer'"
                                        formControlName="SpouseEmployerName"
                                        class="inline-form-input"
                                        [Appearance]="'outline'">
                </enterprise-text-input>
                <enterprise-text-input  [InputId]="'summary-es-input-spouse-employer-phone'"
                                        [InputName]="'SpouseEmployerPhone'"
                                        [Label]="SpouseCurrentlyWorking.value === 'Yes'  ?  'Current Employer #' : 'Former Employer #'"
                                        formControlName="SpouseEmployerPhone"
                                        ButtonIcon="phone"
                                        [ButtonDisabled]="true"
                                        [Mask]="PhoneFormat"
                                        [ShowButton]="true"
                                        class="inline-form-input"
                                        [Appearance]="'outline'">
                </enterprise-text-input>
            </div>
        </div>

    </div>
    <div class="survey-step-header">
        <h3 class="survey-step-title">Section 4: Other Benefits</h3>
    </div>
    <div id="summary-ob-form" *ngIf="OtherBenefitForm" [formGroup]="OtherBenefitForm" class="form-section mt-1rem mb-1rem">
        <label class="label-question br-1">
           Self
        </label>
        <div id="summary-ob-form-section-1" class="checkbox-grip">
                <mat-checkbox id="summary-chkbox-retire-plan" #RetireePlan [checked] = "RetireePlan" formControlName="RetireePlan">
                    <span class=checkbox-item>Retiree Plan</span>
                </mat-checkbox>
                <mat-checkbox id="summary-chkbox-long-term-disability" #LongTermDisability [checked] = "LongTermDisability" formControlName="LongTermDisability">
                    <span class=checkbox-item>Long-term Disability</span>
                </mat-checkbox>
                <mat-checkbox id="summary-chkbox-cobra" #COBRAContinuationOfCoverage [checked] = "COBRAContinuationOfCoverage" formControlName="COBRAContinuationOfCoverage">
                    <span class=checkbox-item>COBRA Continuation of Coverage</span>
                </mat-checkbox>
                <mat-checkbox id="summary-chkbox-worker-compensation" #WorkersCompensation [checked] = "WorkersCompensation" formControlName="WorkersCompensation">
                    <span class=checkbox-item>Worker's Compensation</span>
                </mat-checkbox>
                <mat-checkbox id="summary-chkbox-short-term-disability" #ShortTermDisability [checked] = "ShortTermDisability" formControlName="ShortTermDisability">
                    <span class=checkbox-item>Short-term Disability</span>
                </mat-checkbox>
        </div>
        <label class="label-question mt-1rem br-1">
            Spouse
         </label>
        <div id="summary-ob-form-section-2" class="checkbox-grip">

            <mat-checkbox id="summary-chkbox-spouse-retire-plan" #SpouseRetireePlan [checked] = "SpouseRetireePlan" formControlName="SpouseRetireePlan">
                <span class=checkbox-item>Spouse Retiree Plan</span>
            </mat-checkbox>
            <mat-checkbox id="summary-chkbox-spouse-long-term-disability" #SpouseLongTermDisability [checked] = "SpouseLongTermDisability" formControlName="SpouseLongTermDisability">
                <span class=checkbox-item>Spouse Long-term Disability</span>
            </mat-checkbox>
            <mat-checkbox id="summary-chkbox-spouse-cobra" #SpouseCOBRAContinuationOfCoverage [checked] = "SpouseCOBRAContinuationOfCoverage" formControlName="SpouseCOBRAContinuationOfCoverage">
                <span class=checkbox-item>Spouse COBRA Continuation of Coverage</span>
            </mat-checkbox>
            <mat-checkbox id="summary-chkbox-spouse-worker-compensation" #SpouseWorkersCompensation [checked] = "SpouseWorkersCompensation" formControlName="SpouseWorkersCompensation">
                <span class=checkbox-item>Spouse Worker's Compensation</span>
            </mat-checkbox>
            <mat-checkbox id="summary-chkbox-spouse-short-term-disability" #SpouseShortTermDisability [checked] = "SpouseShortTermDisability" formControlName="SpouseShortTermDisability">
                <span class=checkbox-item>Spouse Short-term Disability</span>
            </mat-checkbox>
        </div>
    </div>
    <div class="survey-step-header">
        <h3 class="survey-step-title">Section 5: Contact Information</h3>
    </div>
    <div id="summary-contact-form" *ngIf="ContactForm" [formGroup]="ContactForm" class="form-section mt-1rem mb-1rem">
        <div class="inline-item">
            <mat-checkbox id="summary-chkbox-is-acknowledge" [checked] = "true" formControlName="IsAcknowledge">
                <span>By clicking this checkbox, you acknowledge that all information listed is true and correct to the best of your knowledge.</span>
            </mat-checkbox>
        </div>
        <div class="inline-item">
            <mat-checkbox id="summary-chkbox-is-signed" [checked] = "true" formControlName="IsSigned">
                <span>By clicking this checkbox, you agree to sign this form electronically in place of a digital or printed signature.</span>
            </mat-checkbox>
        </div>
        <div class="inline-item mt-1rem mb-1rem">
            <enterprise-text-input  [InputId]="'summary-contact-input-name'"
                                    [InputName]="'Name'"
                                    [ErrorMessageOverride]="SetErrorTooltipMessage('Name', 'Name')"
                                    Label="Name"
                                    formControlName="Name"
                                    class="inline-form-input"
                                    [MaxLength]="NameMaxLength"
                                    [Appearance]="'outline'">
            </enterprise-text-input>
            <enterprise-date-input
                                    [InputId]="'summary-contact-date-contact-date'"
                                    [InputName]="'ContactDate'"
                                    id="summary-contact-date-contact-date"
                                    Label="Date"
                                    formControlName="ContactDate"
                                    class="inline-form-input"
                                    [Appearance]="'outline'"
                                    [ReadOnly]="true">
            </enterprise-date-input>
            <app-input-phone id="summary-contact-input-phone"
                             [Label]="'Daytime Phone #'"
                             [Form]="ContactForm"
                             [FormControlName]="'DayTimePhone'"
                             [ButtonDisabled]="true"
                             [ShowButton]="true"
                             [InputId]="'summary-contact-input-phone'"
                             [InputName]="'DayTimePhone'">
            </app-input-phone>
            <enterprise-text-input  [InputId]="'summary-contact-input-email'"
                                    [InputName]="'Email'"
                                    Label="E-mail Address"
                                    formControlName="Email"
                                    class="inline-form-input"
                                    [MaxLength]="EmailMaxLength"
                                    [Appearance]="'outline'">
            </enterprise-text-input>
        </div>
    </div>
</div>
